import { doc } from "firebase/firestore";
import * as Firebase from "@/firebase/Firebase";

export function deserializeConfiguration(x: any) {


    x.oilElements = x.oilElementsPath == null ? null : x.oilElementsPath.map(x => doc(Firebase.firestore, x));
    x.temperatureElements = x.temperatureElementsPath == null ? null : x.temperatureElementsPath.map(x => doc(Firebase.firestore, x));
    x.traceabilityElements = x.traceabilityElementsPath == null ? null : x.traceabilityElementsPath.map(x => doc(Firebase.firestore, x));

    return x;
}

export function deserializeResult(x: any) {

    for (let traceability of x.traceability) {

        traceability.element = traceability.elementPath == null ? null : doc(Firebase.firestore, traceability.elementPath);

        console.log(traceability);
    }
    return x;
}